"use strict";

angular.module("app.breadcrumb", []).//

service("breadcrumbService", ['$rootScope', '$state','$location',
    function ($rootScope, $state,$location) {
        var stateHistory = [];
        var actual;
        var backButton;
        var lastViewScope = $rootScope;

        var getName = function (stateName, scope) {
            if (typeof stateName === "function") {
                return stateName(scope);
            } else {
                return stateName;
            }
        };



        var getIndexOfDuplicate = function (actualState) {
            for (var i = 0; i < stateHistory.length; ++i) {
                var duplicated = actualState.state['name'] === stateHistory[i].state['name'];
                if (duplicated) {
                    var sameParameters = true;

                    let actObj = actualState.params;
                    let histObj = stateHistory[i].params;

                    for (var par in actObj) {

                        if (actObj.hasOwnProperty(par)
                            && histObj.hasOwnProperty(par)
                            && !deepCompare([actObj[par], histObj[par]])
                        ) {
                            sameParameters = false;
                            break;
                        }
                    }
                    if (sameParameters) {
                        return i;
                    }
                }
            }
            return -1;
        };


        var deleteBreadcrumbTail = function (index) {
            stateHistory = stateHistory.slice(0, index);
        };

        var pushNewSate = function (newEntry, state, params, scope) {
            // add additional information to new entry
            newEntry['index'] = stateHistory.length;
            newEntry['name'] = getName(state["breadcrumb"]["name"], scope);
            newEntry['displayName'] = getName(state["breadcrumb"]["name"], scope);
            newEntry['state'] = state;
            newEntry['params'] = params;
            newEntry['goTo'] = function() {
                $state.go(state.name, params);
            };

            // push new entry to history stack
            stateHistory.push(newEntry);
        };

        var addState = function () {

            if (!actual) {
                //TODO: insert loading from cache
                actual = {
                    state: $state.current,
                    params: $state.params
                };
            }

            var state = actual.state;
            var params = actual.params;
            var scope = lastViewScope;

            // reset state history in case of an initial state
            if (state["breadcrumb"] && state["breadcrumb"]["initialState"]) {
                stateHistory = [];
            }

            //check whether state has to be ignored
            if (state["abstract"] || (state["breadcrumb"] && state["breadcrumb"]["ignore"])) {
                return;
            }

            //check whether state is not defined
            if (!state["breadcrumb"] || !state["breadcrumb"]["name"]) {
                console.warn("The state '" + state.name + "' has no breadcrumb defined!");
                return;
            }


            // init new entry basic version
            var newEntry = {
                state: state,
                params: params
            };


            var index = getIndexOfDuplicate(newEntry);
            if (index < 0) {
                pushNewSate(newEntry, state, params, scope);
            } else { // prevent duplicated states
                deleteBreadcrumbTail(index + 1);
            }

        };
        addState();
        $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams)
        {
            actual = {
              state: toState,
              params: toParams
            };

        });

        $rootScope.$on('$locationChangeSuccess', function() {
            $rootScope.actualLocation = $location.path();
        });

        var a = this;
        $rootScope.$watch(function() {
            return $location.path();
        }, function(newLocation, oldLocation) {
            if ($rootScope.actualLocation === newLocation) {
                a.goBack();
            }
        });

        // Browser Button
        $rootScope.$on('$viewContentLoaded', function (event, toState) {
            lastViewScope = event.targetScope;
            if(!backButton){
                addState();
            }
            backButton = false;

        });


        this.getBreadcrumb = function () {
            return stateHistory;
        };

        this.goBack = function () {
            if (stateHistory === undefined || stateHistory.length < 2) {
                // If we jauare on last Item and push Back => Redirect to Main
                stateHistory = [];
                $state.go('main');
            } else {
                stateHistory[stateHistory.length - 2].goTo();
            }

        };

        this.isBack = function () {
            var blockStates = ['main', 'login'];
            //console.log('Length'+stateHistory.length);
            return (stateHistory.length >= 1 && blockStates.indexOf(stateHistory[0]['name']) === -1);
        };
        this.popLastState = function(){
            stateHistory.splice( stateHistory.length-1,1);
        };

    }
]).//

directive('kermiBreadcrumb', ['$rootScope', 'breadcrumbService',
    function ($rootScope, breadcrumbService) {
        return {
            restrict: 'A',
            scope: {},
            templateUrl: 'views/breadcrumb/breadcrumb.html',

            /* @ngInject */
            controller: function ($scope) {
                'ngInject';

                $scope.breadcrumb = breadcrumbService.getBreadcrumb();

                $rootScope.$on('$viewContentLoaded', function () {
                    $scope.breadcrumb = breadcrumbService.getBreadcrumb();
                });

            }
        };
    }
]);
